export default __webpack_public_path__ + "static/media/OrchestraitLogoHeader.31248687.svg";